import { useStyles } from "./PauseHeroButton.styles"
import { TakisSvg } from "./TakisSvgs"
import { useLanguage, supportedLanguages } from "../hooks/useLanguage";

const PauseHeroButton = ({ isPaused, isActive, onClick }) => {
  const classes = useStyles();
  const language = useLanguage();

  const actionTitle = language === supportedLanguages.es
      ? (isPaused ? 'tocar' : 'pausar') + 'video de fondo'
      : (isPaused ? 'play' : 'pause') + ' background video';

  return (
    <button
      className={`
        ${classes.pauseHeroButton}
        ${isActive ? 'isActive' : ''}
      `}
      onClick={onClick}
      title={actionTitle}
      aria-hidden={!isActive}
      >
      <div
        className={classes.pauseHeroButton_svg}
        >
        {isPaused &&
          <TakisSvg
            icon={'playArrow'}
            svg_class={classes.pauseHeroButton_play}
            ariaHidden="true"
            />
        }
        {!isPaused &&
          <TakisSvg
            icon={'pause'}
            svg_class={classes.pauseHeroButton_pause}
            ariaHidden="true"
            />
        }
      </div>
    </button>
  )
}

export default PauseHeroButton
